/**
 * A column filter holds the values a column is narrowed to. Undefined is every
 * value, the state of a column nobody has filtered; an empty list is no value,
 * so no row.
 */
export type ColumnSelection = string[] | undefined

export const passes = (selected: ColumnSelection, value: string): boolean => !selected || selected.includes(value)

/** The selection as one line of an export or a status: All, None, or the values named. */
export function selectionText(selected: ColumnSelection, labelOf: (value: string) => string = (value) => value): string {
  if (!selected) return 'All'
  return selected.length === 0 ? 'None' : selected.map(labelOf).join(', ')
}
